import React from 'react';
export function SiteFooter() {
  return <footer className="w-full bg-pitch" data-id="element-171" data-mp="3rjvz5hlqcyja">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center" data-id="element-172" data-mp="1bettc3zu76jg">
        <p className="text-lg font-extrabold text-white" data-id="element-173" data-mp="1bh6kn7rhit96">Método Fútbol Digital</p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-body" data-id="element-174" data-mp="1fh6wqlr42sd2">
          El método para que padres y madres acompañen, protejan y planifiquen la carrera
          futbolística de sus hijos e hijas.
        </p>
        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-body" data-id="element-175" data-mp="nnof1t9jomb9">
          <li data-id="element-176" data-mp="wq60i5hdlax7">
            <a href="mailto:solucionesoinformacion@gmail.com" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-177" data-mp="wpnvokgndodo">
              📧 solucionesoinformacion@gmail.com
            </a>
          </li>
          <li data-id="element-178" data-mp="3zfmhi43aeb8">
            <a href="https://instagram.com/metodofutboldigital" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-179" data-mp="3znxf4gnj9js">
              📱 @metodofutboldigital
            </a>
          </li>
          <li data-id="element-180" data-mp="6ml1p3s82vnz">
            <a href="https://metodofutboldigital.shop" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-181" data-mp="6m1scbgn1flk">
              🌐 metodofutboldigital.shop
            </a>
          </li>
        </ul>
        <p className="mt-8 text-xs text-subtle" data-id="element-182" data-mp="3o2jcqs6nfb1s">
          Acceso digital inmediato · Material en PDF · Soporte por correo
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-xs leading-relaxed text-subtle" data-id="element-183" data-mp="3j25hkaq5bvl6">
          Este material es educativo y no reemplaza la asesoría de un abogado especializado en
          derecho deportivo. Los procedimientos varían según el país y de acuerdo con la normativa
          vigente: verifica con la federación correspondiente y consulta con un profesional
          especializado antes de firmar.
        </p>
        <p className="mt-3 text-xs text-subtle" data-id="element-184" data-mp="188su2oximbk2">
          © 2026 Método para padres de futbolistas™ — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}